<template>
  <div class="verification-details-photos">
    <template v-if="quickbuyVerificationDetails.isNotEmptySelfie">
      <div class="verification-details-photos__section">
        <h3 class="verification-details-photos__subtitle">
          {{ 'verification-details.key-selfie' | globalize }}
        </h3>

        <div class="verification-details-photos__img-wrp">
          <img
            class="app__img-preview"
            :src="quickbuyVerificationDetails.documents.selfie"
            @click="
              selectPhotoUrl(quickbuyVerificationDetails.documents.selfie)"
          >
        </div>
      </div>
    </template>

    <template v-if="quickbuyVerificationDetails.isNotEmptyDocImages">
      <div class="verification-details-photos__section app-key-value__row">
        <button
          v-ripple
          class="verification-details-photos__dropdown-btn"
          type="button"
          @click="isImagesDocsShown = !isImagesDocsShown"
        >
          <i
            class="mdi verification-details-photos__dropdown-btn-icon"
            :class="{
              'mdi-chevron-right': !isImagesDocsShown,
              'mdi-chevron-down': isImagesDocsShown
            }"
          />
          <h3 class="verification-details-photos__subtitle">
            {{ 'verification-details.key-document-images' | globalize }}
          </h3>
        </button>
        <template v-if="isImagesDocsShown">
          <div class="verification-details-photos__img-wrp">
            <img
              class="app__img-preview"
              v-for="
                image in quickbuyVerificationDetails.documents.documentImages"
              :key="image"
              :src="image"
              @click="selectPhotoUrl(image)"
            >
          </div>
        </template>
      </div>
    </template>

    <photo-viewer
      v-if="selectedPhotoUrl"
      :img-url="selectedPhotoUrl"
      :is-shown.sync="isImageViewerShown"
    />
  </div>
</template>

<script>
import { QuickbuyVerificationRecord } from '@/js/records/entities/quickbuy-verification.record'
import PhotoViewer from '@/vue/common/PhotoViewer'

export default {
  name: 'verification-details-photos',
  components: { PhotoViewer },
  props: {
    quickbuyVerificationDetails: {
      type: QuickbuyVerificationRecord,
      required: true,
    },
  },
  data: () => ({
    selectedPhotoUrl: '',
    isImageViewerShown: false,
    isImagesDocsShown: false,
  }),
  methods: {
    selectPhotoUrl (url) {
      this.selectedPhotoUrl = url
      this.isImageViewerShown = true
    },
  },
}
</script>

<style lang="scss">
.verification-details-photos__subtitle {
  margin-bottom: 2rem;
}

.verification-details-photos__section {
  margin-top: 3rem;
}

.verification-details-photos__img-wrp {
  display: flex;
  gap: 1rem;
  max-width: 15rem;
  width: 100%;
}

.verification-details-photos__dropdown-btn {
  display: flex;
  justify-content: flex-start;
  margin-top: 1rem;
}

.verification-details-photos__dropdown-btn-icon {
  display: block;
  font-size: 2rem;
  height: 2rem;
  width: 2rem;
  line-height: 1.8rem;
  transition: all 0.3s;
}
</style>
